"use strict";

define('components/editable_module',['components/ajax', 'components/form', 'components/dom_setup'], function(ajax, form, domSetup) {

    var editableModule = {

        init: function(node) {
            var self = this;
            node.find('.edit-link').click(function(e) {
                e.preventDefault();
                e.stopPropagation();
                self.togglePreviewButton($(this).closest('.module'), false);
                self.togglePlacementLabel($(this).closest('.module'), false);
                self.switchToEditView($(this), $(this).data('edit-url'), $(this).data('module-id'));
            });
        },

        scrollToTop: function(module) {
            var viewportTop = $(window).scrollTop();
            const offset = module.offset();
            if (offset && offset.top < viewportTop) {
                $('html,body').animate({scrollTop: offset.top-90});
            }
        },

        togglePreviewButton: function(module, show) {
            var previewButton = module.find('.watermark_preview_btn_saved');
            if (previewButton.length) {
                previewButton.toggle(show);
            }
        },

        togglePlacementLabel: function(module, show) {
            var placementLabel = module.find('[id^="watermark-placement-label-right-"]');
            var placementLabelContainer = module.find('[id^="watermark-placement-label-right-container"]');
            if (placementLabel.length) {
                placementLabel.toggle(show);
                placementLabelContainer.toggle(show);
            }
        },

        switchToReadView: function(editLink) {
            var viewUrl = editLink.data('view-url');
            var moduleId = editLink.data('module-id');
            var module = $('#'+moduleId);
            this.togglePreviewButton(module.closest('.module'), true);
            this.togglePlacementLabel(module.closest('.module'), true);
            $.get(viewUrl, null, function(result) {
                module.off('click', 'button');
                module.html(result);
                module.removeClass('bg-info').removeClass('module-body-edit');
                domSetup.init(module);
            });
            editLink.closest('.action-links').find('.btn').removeClass('disabled');
            this.scrollToTop(module);
        },

        previewWatermarkEditMode: function(module, previewLink, prevButton) {
            var self = this;
            var editForm = module.find('form');
            var formData = form.serialize(editForm);

            require(['components/preview_watermark_utils'], function(previewWatermarkUtils) {
                previewWatermarkUtils.handlePreview({
                    previewUrl: previewLink,
                    formData: formData,
                    modalOptions: {
                        modalId: 'preview-pdf-modal',
                        modalBodyHeight: '80vh'
                    },
                    beforePreview: function() {
                        prevButton.addClass('disabled')
                            .prop('disabled', true);
                        module.find('.module-overlay')
                            .removeClass('hidden');
                    },
                    onModalClose: function() {
                        prevButton.removeClass('disabled')
                            .prop('disabled', false);
                        module.find('.module-overlay')
                            .addClass('hidden');
                        $('#custom-backdrop').remove();
                    },
                    onPreviewFailure: function(result) {
                        var editForm = self.initEditModule(module, result.body),
                            errorSection = editForm.find('.has-error');
                        if (!errorSection.length) {
                            errorSection = editForm.find('.alert')
                        }
                        self.scrollToTop(errorSection.first());
                    },
                    onPreviewError: function(result) {
                        prevButton.removeClass('disabled')
                            .prop('disabled', false);
                        module.find('.module-overlay')
                            .addClass('hidden');
                    }
                });
            });
        },

        switchToEditView: function(editLink, editUrl, moduleId) {
            editLink.closest('.action-links').find('.btn').addClass('disabled');
            // getting current watermark id
            var currentWatermarkId = editUrl.split('/edit')[0].split('/').pop();
            var self = this;
            $.ajax({
                url: editUrl,
                type: 'GET',
                processData: false,
                success: function(result) {
                    var module = $('#'+moduleId);

                    // Set the module content with the result returned by the server
                    self.initEditModule(module, result);

                    // Bind and button events
                    module.on('click', 'button', function(e) {
                        e.preventDefault();
                        var button = $(e.target);
                        var buttonName = button.attr('name');

                        if (buttonName == 'cancel') {
                            self.switchToReadView(editLink);
                            return false;
                        }
                        if (buttonName == 'save') {
                            self.submitForm(module, editLink, button);
                        }

                        if (buttonName === 'preview'){
                            self.previewWatermarkEditMode(module, '/admin_settings/document_watermarks/' + currentWatermarkId + '/preview_draft', button);
                        }
                    });
                },
                error: function(result) {
                    editLink.closest('.action-links').find('.btn').removeClass('disabled');
                },
            });
        },

        submitForm: function(module, editLink, saveButton) {
            var self = this;
            var editForm = module.find('form');
            var formData = form.serialize(editForm);
            var url = editLink.data('edit-url')
            var currentModuleIdNum = url.split('/edit')[0].split('/').pop();
            var moduleId = editLink.data('module-id');
            var POLL_WAIT = 3000;  // Wait 3 seconds between polls
            var POLL_MAX_COUNT = 900;  // Max 900 polls (2700 seconds = 45 minutes)

            // Disable the save button and show the overlay while waiting for the ajax request to complete
            saveButton.addClass('disabled')
                      .prop('disabled', true);
            module.find('.module-overlay')
                  .removeClass('hidden');

            var successAction = function(result) {
                module.html(result.body)
                domSetup.init(module);
                module.off('click', 'button');
                editLink.closest('.action-links').find('.btn').removeClass('disabled');
                module.find(".triggerWindowEvent").each(function() {
                    var eventName = $(this).data('event-name');
                    var eventDetailKey = $(this).data('event-detail-key');
                    var eventDetailValue = $(this).val();
                    var eventDetailObject = {}
                    eventDetailObject[eventDetailKey] = eventDetailValue;
                    window.dispatchEvent(new CustomEvent(eventName, {detail: eventDetailObject}));
                })

                // Get new placement value and update it to placement position info
                const newPlacementLabel = editForm.serializeArray().find(function(item) {
                    return item.name === 'placement';
                })
                var placementLabel = module.closest('.module').find('[id^="watermark-placement-label-right-' + currentModuleIdNum + '"]');
                if (placementLabel.length && newPlacementLabel) {
                    if(newPlacementLabel.value === 'diagonal-middle-center' || newPlacementLabel.value.toLowerCase() === 'diagonal-middle-center') {
                        placementLabel.text('Diagonal (middle-center)');
                    } else {
                        placementLabel.text(newPlacementLabel.value);
                    }                }

                // Toggle preview button with respect to edit mode
                self.togglePreviewButton(module.closest('.module'), true);
                self.togglePlacementLabel(module.closest('.module'), true);
                if (result.hideEditLink) {
                    editLink.addClass('disabled');
                }

                self.scrollToTop(module);
                module.removeClass('bg-info').removeClass('module-body-edit');
            }
            var failureAction = function(result) {
                var editForm = self.initEditModule(module, result.body),
                    errorSection = editForm.find('.has-error');
                if (!errorSection.length) {
                    errorSection = editForm.find('.alert')
                }
                self.scrollToTop(errorSection.first());
            }
            var errorAction = function(result) {
                module.find('.module-overlay')
                      .addClass('hidden');
                saveButton.removeClass('disabled')
                          .prop('disabled', false);
            }
            var scrollToErrorMessage = function() {
                // Scroll to the top if the error alert is not in the view port
                var alert_message = $('#alert-message');
                var viewportTop = $(window).scrollTop();
                if (alert_message.offset().top < viewportTop) {
                    $('html,body').animate({scrollTop: alert_message.offset().top - $('.navbar-fixed-top').offset().top});
                }
            };

            ajax(url, {
                formData: formData,
                onSuccess: function(result) {
                    if (!result.poll_url_editable_module) {
                        successAction(result)
                    }
                    else{
                        var pollCount = 0;
                        var makeRequest = function() {
                            setTimeout(function(){
                                ajax(result.poll_url_editable_module, {
                                    formData: formData,
                                    onSuccess: function(result) {
                                        if (result.ajax_url) {
                                            ajax(result.ajax_url, {
                                                formData: formData,
                                                onSuccess: function(result) {
                                                    successAction(result)
                                                },
                                                onFailure: function(result) {
                                                    failureAction(result)
                                                },
                                                onError: function(result) {
                                                    errorAction(result)
                                                }
                                            })
                                        }

                                        pollCount += 1;
                                        var job_done = (result.job_status == 'Completed') ||
                                            (result.job_status == 'Error');
                                        var too_long = pollCount > POLL_MAX_COUNT;
                                        if (job_done || too_long) {
                                            var error_message = null;
                                            if (typeof result.error_message !== 'undefined' && result.error_message) {
                                                error_message = result.error_message;
                                            } else if (pollCount > POLL_MAX_COUNT) {
                                                error_message = 'Request timed out.'
                                            }
                                            if (error_message) {
                                                var alert_message = $('#alert-message');
                                                alert_message.html(error_message);
                                                alert_message.addClass('alert-danger');
                                                alert_message.removeClass('hidden');
                                                scrollToErrorMessage();
                                            }
                                        } else {
                                            makeRequest();
                                        }
                                    }
                                });
                            }, POLL_WAIT);
                        };
                        makeRequest();
                    }
                },
                onFailure: function(result) {
                    failureAction(result)
                },
                onError: function(result) {
                    errorAction(result)
                }
            });
        },
        // Pillar needs to be manually rendered when content is async loaded behind an edit button
        initEditor: function() {
            if (typeof window.__jsqRenderPillars__ === "function") {
                window.__jsqRenderPillars__();
            }
        },
        initEditModule: function(module, content) {
            content += '<div class="module-overlay hidden"><img src="/static/spinner_sm.gif" width="16" height="16"></div>';
            module.html(content);
            module.addClass('bg-info').addClass('module-body-edit');

            var moduleComponentName = module.children('div').data('module-component');
            if (moduleComponentName && moduleComponentName !== 'editor') {
                require(['components/'+moduleComponentName], function(component) {
                    component.init(module);
                });                
            }
            
            if (moduleComponentName === 'editor') {
                this.initEditor();
            }
            domSetup.init(module);
            var editForm = module.find('form');
            form.focusFirstInput(editForm);
            return editForm;
        }
    };

    return editableModule;

});


